const BASEURL = `${process.env.PUBLIC_URL}/assets/img/`;

export const about = {
  pageTitle: "About",
  alt: "Touhid Alam Photo",
  image: `${process.env.PUBLIC_URL}/assets/img/blcak-Versity-down.jpg`,
  aboutText1: `I’m a Junior Web Developer located in Dhaka, Bangladesh. I have a serious passion for UI effects, animations and, dynamic user experiences.`,
  aboutText2: `Well-organized person, problem solver, independent employee with high attention to detail. Outdoor activities, Games and Travelling.`,
  aboutText3: `Interested in the entire MERN Stack and working on ambitious projects with positive people.`,
};

export const project = {
  pageTitle: "Some Things I’ve Built",
};

export const projectList = [
  {
    id: 1,
    borderColor: "#492792",
    heading: "Landing Page Material-UI",
    subTitle:
      "Focus on Landing Page, Card, custom design by MUI and react js useLayoutEffect",
    usingTechnology: "React Js, Material-UI, React-Scroll, Firebase",
    githubLink: "https://github.com/touhidalam09/Landing-page-design-mui",
    liveDemo: "https://muilandpage.web.app/",
    image: `${BASEURL}muiland.png`,
  },
  {
    id: 2,
    borderColor: "#FF2253",
    heading: "WorldWebDesk PSD to html",
    subTitle:
      "Its practice project built in Responsive, Pixel Perfect, from PSD to HTML and only CSS and Media Query used.",
    usingTechnology: "HTML, CSS, CSS-Media-Query, Font-Awesome, PSD",
    githubLink: "https://github.com/touhidalam09/worldwebdesk",
    liveDemo: "https://touhidalam09.github.io/worldwebdesk/",
    image: `${BASEURL}WorldWeDesk.png`,
  },
  {
    id: 3,
    borderColor: "#492792",
    heading: "Arka Hosting PSD to Bootstrap",
    subTitle:
      "Its practice project built in Responsive, Pixel Perfect, from PSD to HTML and Bootstrap v4",
    usingTechnology: "HTML, CSS, Bootstrap v4, Font-Awesome, PSD",
    githubLink: "https://github.com/touhidalam09/ArkaHosting-with-Bootstrap-v4",
    liveDemo: "https://touhidalam09.github.io/ArkaHosting-with-Bootstrap-v4/",
    image: `${BASEURL}arka.png`,
  },
  {
    id: 4,
    borderColor: "#D26CD5",
    heading: "Material-UI Management System",
    subTitle:
      "Layout Design, Employee Modal Form, Data-Table, onChange Searching, Sorting, Pagination, Action cell, Mui-Alert and also using reuseable components ",
    usingTechnology: "React JS, MUI, Firebase",
    githubLink: "https://github.com/touhidalam09/complete-mui-system",
    liveDemo: "https://muisystm.web.app/",
    image: `${BASEURL}muicmpltsys.png`,
  },
  {
    id: 5,
    borderColor: "#08FDD8",
    heading: "JavaScript Mini-Projects",
    subTitle: "Its practice project using JavaScript language.",
    usingTechnology: "HTML, JavaScript",
    githubLink:
      "https://github.com/touhidalam09/all_in_one_JavaScript_Mini_Project",
    liveDemo:
      "https://touhidalam09.github.io/all_in_one_JavaScript_Mini_Project/",
    image: `${BASEURL}javaScriptProject.png`,
  },
  {
    id: 6,
    borderColor: "#F74068",
    heading: "HTML CSS Bootstrap Projects",
    subTitle:
      "ALl project in One Landing Page. Its practice project built in Responsive, Pixel Perfect, from PSD to HTML, Sign up, Sign in, Facebook fishing page etc. Better understand please checkout live preview",
    usingTechnology:
      "HTML, CSS, CSS-Media-Query, Font-Awesome, Bootstrap, Design, Login, Sing up, PSD",
    githubLink:
      "https://github.com/touhidalam09/all_in_one_design_by_CSS-Bootstrap-project",
    liveDemo:
      "https://touhidalam09.github.io/all_in_one_design_by_CSS-Bootstrap-project/",
    image: `${BASEURL}design.png`,
  },
];

export const contact = {
  pageTitle: "Contact",
  email: "touhidalam649@gmail.com",
  mobile: "+8801682857383",
  github: "https://github.com/touhidalam09",
  linkedIn: "https://www.linkedin.com/in/touhid-alam-09/",
  contactText:
    "If you have other request or question, don’t hesitate to use the form.",
};

export const skillExperience = {
  pageTitle: "Skill & Experience",
  skillText:
    "I create successful responsive websites that are fast, easy to use, user friendly, and built with best practices. The main area of my expertise is front-end development, JS, React JS, Material-UI, building small and medium web apps, custom plugins, features, animations, and coding interactive layouts.",
};

export const skillProfessionsList = [
  {
    id: 1,
    color: "#08FDD8",
    designation: "Apprentice Software Engineer",
    company: "Swapnoloke",
    date: "2020-2021",
    jobDetails:
      "Development Product Management Software using PHP, Laravel, Ajax, jQuery, Bootstrap, CSS, Html, also plugins Excel, and pdf downloading.",
  },
  {
    id: 2,
    color: "#492792",
    designation: "Freelancer - React JS Developer",
    company: "Upwork",
    date: "2020-",
    jobDetails:
      "Web Development and Web Design, React JS, Material-UI, Bootstrap, CSS, Html.",
  },
];

export const skills = [
  {
    skillName: "React JS",
    progressColor: "#FF2253",
    progressValue: "75",
  },
  {
    skillName: "Material-UI",
    progressColor: "#D26CD5",
    progressValue: "70",
  },
  {
    skillName: "JavaScript",
    progressColor: "#08FDD8",
    progressValue: "80",
  },
  {
    skillName: "PHP",
    progressColor: "#F74068",
    progressValue: "70",
  },
  {
    skillName: "LARAVEL",
    progressColor: "#492792",
    progressValue: "55",
  },
];

export const expertTechnology = [
  {
    id: 1,
    title: "I'm currently using",
    component: [
      {
        title2: "React JS",
        alt: "React JS",
        image: `${process.env.PUBLIC_URL}/assets/img/react.png`,
      },
      {
        title2: "Material-UI",
        alt: "Material-UI",
        image: `${process.env.PUBLIC_URL}/assets/img/mui.png`,
      },
      {
        title2: "JavaScript",
        alt: "JavaScript",
        image: `${process.env.PUBLIC_URL}/assets/img/js.png`,
      },
    ],
  },
  {
    id: 2,
    title: "I Know More About",
    component: [
      {
        title2: "PHP",
        alt: "PHP",
        image: `${process.env.PUBLIC_URL}/assets/img/php.png`,
      },
      {
        title2: "Laravel",
        alt: "Laravel",
        image: `${process.env.PUBLIC_URL}/assets/img/laravel.png`,
      },
      {
        title2: "jQuery",
        alt: "jQuery",
        image: `${process.env.PUBLIC_URL}/assets/img/jquery.png`,
      },
      {
        title2: "Bootstrap",
        alt: "Bootstrap",
        image: `${process.env.PUBLIC_URL}/assets/img/Bootstrap.png`,
      },
      {
        title2: "HTML",
        alt: "HTML",
        image: `/assets/img/html.png`,
      },
      {
        title2: "CSS3",
        alt: "CSS3",
        image: `${process.env.PUBLIC_URL}/assets/img/css.png`,
      },
      {
        title2: "SQL",
        alt: "SQL",
        image: `${process.env.PUBLIC_URL}/assets/img/sql.png`,
      },
      {
        title2: "MySql",
        alt: "MySql",
        image: `${process.env.PUBLIC_URL}/assets/img/mysql.png`,
      },
      {
        title2: "JAVA",
        alt: "JAVA",
        image: `${process.env.PUBLIC_URL}/assets/img/java.png`,
      },
      {
        title2: "C",
        alt: "C",
        image: `${process.env.PUBLIC_URL}/assets/img/c.png`,
      },
    ],
  },
  {
    id: 3,
    title: "Some of the technologies I have worked with-",
    component: [
      {
        title2: "GIT",
        alt: "GIT",
        image: `${process.env.PUBLIC_URL}/assets/img/git.png`,
      },
      {
        title2: "GITHUB",
        alt: "GITHUB",
        image: `${process.env.PUBLIC_URL}/assets/img/github.png`,
      },
      {
        title2: "LINUX",
        alt: "LINUX",
        image: `${process.env.PUBLIC_URL}/assets/img/linux.png`,
      },
      {
        title2: "AWS",
        alt: "AWS",
        image: `${process.env.PUBLIC_URL}/assets/img/aws.png`,
      },
      {
        title2: "VS CODE",
        alt: "VS CODE",
        image: `${process.env.PUBLIC_URL}/assets/img/vs.png`,
      },
    ],
  },
];
